import React, { useEffect, useState } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import axios from "axios";
import Fivestarreview from "./reviews/fivestarreview";
import Allreviews from "./reviews/allreviews"
import Fourstarreview from "./reviews/fourstarreviews";
import Threestarreview from "./reviews/threestarreviews";
import Twostarreview from "./reviews/twostarreviews";
import Onestarreview from "./reviews/onestarreviews";

import '../styles/review.css'

const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");
function Reviewheaders() {

  const [toggleState, setToggleState] = useState(1);
    const [reviewfive, setReviewfive] = useState([]);
    const [reviewfour , setReviewfour] = useState([]);
    const [reviewthree, setReviewthree] = useState([]);
    const [reviewtwo, setReviewtwo] = useState([]);
    const [reviewone, setReviewone] = useState([]);

  const getfive = async () => {
    axios.get(`https://shoppee-clone.herokuapp.com/reviewfive/${id}`)
    .then(res => {
        console.log("ratingcount ",res.data[0].ratingcount)
      setReviewfive(res.data[0].ratingcount);
      
  })
  
  };

  const getfour = async () => {
    axios.get(`https://shoppee-clone.herokuapp.com/reviewfour/${id}`)
    .then(res => {
        console.log("ratingcount ",res.data[0].ratingcount)
      setReviewfour(res.data[0].ratingcount);
      
  })
 };
  const getthree = async () => {
    axios.get(`https://shoppee-clone.herokuapp.com/reviewthree/${id}`)
    .then(res => {
        console.log("ratingcount ",res.data[0].ratingcount)
        setReviewthree(res.data[0].ratingcount);
      
  })
};
const gettwo = async () => {
    axios.get(`https://shoppee-clone.herokuapp.com/reviewtwo/${id}`)
    .then(res => {
        console.log("ratingcount ",res.data[0].ratingcount)
        setReviewtwo(res.data[0].ratingcount);
      
  })
};
const getone = async () => {
    axios.get(`https://shoppee-clone.herokuapp.com/reviewone/${id}`)
    .then(res => {
        console.log("ratingcount ",res.data[0].ratingcount)
        setReviewone(res.data[0].ratingcount);
      
  })
};




  useEffect(() => {
    getfive();
    getfour();
    getthree();
    gettwo();
    getone();
  }, []);

  const toggleTab = (index) => {
    setToggleState(index);
  }

  return (


       <div className="container">
<div class="bloc-tabs">
<div className={toggleState === 1 ? "tabs active-tabs" : "tabs"} onClick={() => toggleTab(1)}>All</div>
<div className={toggleState === 2 ? "tabs active-tabs" : "tabs"} onClick={() => toggleTab(2)}>5 star ({reviewfive})</div>
<div className={toggleState === 3 ? "tabs active-tabs" : "tabs"} onClick={() => toggleTab(3)}>4 star ({reviewfour})</div>
<div className={toggleState === 4 ? "tabs active-tabs" : "tabs"} onClick={() => toggleTab(4)}>3 star ({reviewthree})</div>
<div className={toggleState === 5 ? "tabs active-tabs" : "tabs"} onClick={() => toggleTab(5)}>2 star ({reviewtwo})</div>
<div className={toggleState === 6 ? "tabs active-tabs" : "tabs"} onClick={() => toggleTab(6)}>1 star ({reviewone})</div>
</div>

<div className="content-tabs">
<div className={toggleState === 1 ? "content active-content" : "content"}>
    <h2>All Reviews</h2>
    <hr/>
    <p>
    <Allreviews/>
    </p>
  </div>
  <div className={toggleState === 2 ? "content active-content" : "content"}>
    <h2>5 Star Reviews (⭐⭐⭐⭐⭐) </h2>
    <hr/>
    <p>
    <Fivestarreview/>
    </p>
  </div>

  <div className={toggleState === 3 ? "content active-content" : "content"}>
    <h2>4 Star Reviews (⭐⭐⭐⭐)</h2>
    <hr/>
    <p>
    <Fourstarreview/>
    </p>
  </div>

  <div className={toggleState === 4 ? "content active-content" : "content"}>
    <h2>3 Star Reviews (⭐⭐⭐)</h2>
    <hr/>
    <p>
    <Threestarreview/>
    </p>
  </div>

  <div className={toggleState === 5 ? "content active-content" : "content"}>
    <h2>2 Star Reviews (⭐⭐)</h2>
    <hr/>
    <p>
    <Twostarreview/>
    </p>
  </div>

  <div className={toggleState === 6 ? "content active-content" : "content"}>
    <h2>1 Star Reviews(⭐)</h2>
    <hr/>
    <p>
    <Onestarreview/>
    </p>
  </div>
</div>
</div>
  );
}

export default Reviewheaders;